import { colors } from '../../colors';
var button = {
  //Hero button
  linkColorHero: colors.white,
  linkColorHeroHover: colors.white,
  backgroundColorHero: colors.orangish,
  backgroundColorHoverHero: colors.burntOrange,
  borderRadiusHero: '3px',
  linkLineHeightHero: '30px',
  heroButtonPadding: '20px 35px',
  //primary button
  linkColorPrimary: colors.white,
  linkColorPrimaryHover: colors.white,
  backgroundColorPrimary: colors.orangish,
  backgroundColorHoverPrimary: colors.burntOrange,
  borderRadiusPrimary: '3px',
  //secondary button
  linkColorSecondary: colors.white,
  linkColorSecondaryHover: colors.white,
  backgroundColorSecondary: colors.orangish,
  backgroundColorHoverSecondary: colors.burntOrange,
  borderRadiusSecondary: '3px',
  borderColorSecondary: 'transparent',
  borderColorSecondaryHover: 'transparent'
};
export default button;